import ProductTabMain from './main/product-tab-main';
import ProductTabProperties from './properties';
import ProductTabPropertiesExperiment from './properties-experiment';
import ProductTabReviews from './reviews';
import ProductTabReviewsExperiment from './reviews-experiment';
import ProductTabStatistics from './statistics';
import ProductTabStatisticsExperiment from './statistics-experiment';

export {
  ProductTabProperties,
  ProductTabPropertiesExperiment,
  ProductTabReviews,
  ProductTabReviewsExperiment,
  ProductTabMain,
  ProductTabStatistics,
  ProductTabStatisticsExperiment,
};
